import type { SupportCreateTicketRequest } from '@/model/support/api.generated';
import type { CreateTicketResponse } from '@/model/support/dto.generated';
import type { SupportTicketView } from '@/viewmodel/features/support/types';

export function toCreateTicketRequest(
  formData: Record<string, string>,
  email: string,
): SupportCreateTicketRequest {
  return {
    title: formData['title'] ?? '',
    description: formData['description'] ?? '',
    type: formData['type'] ?? '',
    urgency: formData['urgency'] ?? '',
    area: formData['area'] ?? '',
    email,
  };
}

export function toSupportTicketView(ticket: CreateTicketResponse): SupportTicketView {
  return { issueNumber: ticket.issue_number, issueUrl: ticket.issue_url };
}
